export default {
  referralLinks: []
}
